module.exports = __webpack_public_path__ + "static/media/cs3.0163270a.png";